<h2>Département : {{department?.name}}</h2>
<div class="flex-container" fxLayout="row" fxLayoutGap="5px">
    <div fxFlex="50%">
        <div class="flex-container" fxLayout="row" fxLayoutGap="5px">
            <div fxFlex="50%">
                <mat-form-field class="field-full-width">
                    <mat-label>Nom du département</mat-label>
                    <input matInput [(ngModel)]="department.name">
                </mat-form-field>                    
            </div>
        </div>
    </div>
</div>
<button mat-flat-button color="primary" (click)="validate()">Modifier</button>